import React, { useState } from "react";
import { UrlApi } from "../../../../services/apirest";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Snackbar,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

function AltaUsoEnvasado(props) {
  const [alta, setAlta] = useState(props.alta);
  const [datosRow, setDatosRow] = useState({
    uso: "",
  });
  const [disBtn, setDisBtn] = useState(false);
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
    handleClose();
  };

  const handleClose = () => {
    setAlta(!alta);
    if (props.onClose) {
      props.onClose();
    }
  };

  const almacenar = (e) => {
    setDatosRow({
      ...datosRow,
      [e.target.name]: e.target.value,
    });
  };

  const guardarUso = async (e) => {
    setDisBtn(true);
    e.preventDefault();
    await fetch(UrlApi + "/envasado_usos", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        uso: datosRow.uso,
        activo: 1,
      }),
    })
      .then((res) => {
        if (!res.err) {
          console.log("Guardado");
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("El Uso se guardó exitosamente !");
        } else {
          console.log("Error");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };
  
  return (
    <>
      <Dialog fullWidth open={alta} onClose={() => handleClose()} maxWidth="md">
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography fontSize={20} align="center" color="#ffffff">
              Nuevo Uso de Envasado
            </Typography>
          </DialogTitle>
        </Box>
        <form autoComplete="off" onSubmit={guardarUso}>
          <DialogContent>
            <Grid container spacing={1}>
              <Grid item xs={12} py={1} mb={1}>
                <TextField
                  multiline
                  label="Uso"
                  name="uso"
                  size="small"
                  placeholder="..."
                  inputProps={{
                    maxLength: 300,
                  }}
                  focused
                  required
                  fullWidth
                  value={datosRow.uso}
                  onChange={almacenar}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              mt={1}
            >
              <Grid>
                <Button
                  color="error"
                  variant="outlined"
                  onClick={() => handleClose()}
                  style={{ backgroundColor: "#fff" }}
                >
                  Volver
                </Button>
              </Grid>
              <Grid>
                <Button
                  type="submit"
                  color="success"
                  variant="contained"
                  disabled={disBtn}
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </DialogContent>
        </form>
      </Dialog>

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default AltaUsoEnvasado;
